// components/RightColumn.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useStockStore from '../../../stores/useStockStore';
import { useBrokerIntegration } from '../../../contexts/BrokerIntegrationContextCompat';
// import { cleanupDuplicateBrokers, cleanupDuplicateBrokersFromTbl } from '../../../utils/cleanupDuplicateBrokers'; // Removed - file deleted
import { useAuthContext } from '../../../contexts/AuthContext';

import AddStockButton from './AddStockButton';
import PortfolioSection from './PortfolioSection';
import IronCondorInactivity from './IronCondorInactivity';
import NotificationsSection from './NotificationsSection';
import DisclaimerModal from './DisclaimerModal';
import BrokerConnectionStatus from '../../../components/broker/BrokerConnectionStatus';
import TradeStats from './TradeStats';
import PerformanceCharts from './PerformanceCharts';

const RightColumn = ({ totalPortfolioValue }) => {
  // Debug logging removed to prevent infinite re-renders
  const { showWatchlistModal, showDisclaimerModal, setShowDisclaimerModal } = useStockStore();
  const navigate = useNavigate();
  const { 
    refreshIntegrations,
    hasExpiredConnections,
    expiredConnections,
    connectionCount
  } = useBrokerIntegration();
  const { user, userProfile } = useAuthContext();

  // Refresh broker integrations and cleanup duplicates when component mounts (only once)
  const initializedRef = useRef(false);
  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;
    const refreshData = async () => {
      try {
        // Clean up duplicates first - function removed
        if (user?.uid && userProfile?.username) {
          console.log('🧹 Duplicate cleanup function has been removed');
        }
        
        // Then refresh integrations
        await refreshIntegrations();
        console.log('✅ Dashboard: Broker integrations refreshed on mount');
      } catch (error) {
        console.warn('⚠️ Dashboard: Failed to refresh integrations on mount:', error);
      }
    };

    refreshData();
  }, [refreshIntegrations, user, userProfile]);


  return (
    <>
      <div className="portfolio-info mb-6 text-center">
        <h3 className="font-bold text-xl pb-2" style={{ borderBottom: '1px solid #0b0d2a' }}>STRATEGY CENTER</h3>
      </div>
      
      {/* Broker & Trading Section */}
      <div data-broker-section>
        <BrokerConnectionStatus showAddButton={true} compact={false} />
      </div>
      
      {/* Add Stock Button */}
      <AddStockButton />
      
      {/* Portfolio Section */}
      <PortfolioSection totalPortfolioValue={totalPortfolioValue} />
      
      {/* Notifications Section */}
      <NotificationsSection />
      
      {/* Iron Condor Inactivity */}
      {/*<IronCondorInactivity /> */}

      {/* Disclaimer Modal */}
      {showDisclaimerModal && (
        <DisclaimerModal
          onCancel={() => setShowDisclaimerModal(false)}
          onAgree={() => {
            setShowDisclaimerModal(false);
            navigate('/watchlist');
          }}
        />
      )}
    </>
  );
};

export default RightColumn;
